var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.view == 'articulos')?_c('div',[_c('view-component',{attrs:{"model_name":"article","papelera":"","show_filter_modal":"","show_previus_days":false}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }